export default __webpack_public_path__ + "static/media/Montserrat-VariableFont_wght.7e687123.ttf";